export function encodePathSegment(value) {
    return encodeURIComponent(value);
}
export function createQuery(params) {
    const query = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value == null) {
            continue;
        }
        query.set(key, String(value));
    }
    return query;
}
export function buildUrl(baseUrl, path, options) {
    const url = new URL(path, baseUrl);
    if (options?.query != null) {
        for (const [key, value] of options.query.entries()) {
            url.searchParams.append(key, value);
        }
    }
    return url;
}
//# sourceMappingURL=query.js.map